// 🛒 Shared POG MARKET lookup — one cached fetch, used by the rail + deals panel.
import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let cache = null;
let inflight = null;

const fetchMarket = () => {
  if (cache) return Promise.resolve(cache);
  if (!inflight) {
    inflight = axios.get(`${API}/market/rewards`).then((r) => {
      const byBiz = new Map();
      (r.data.rewards || []).forEach((rw) => {
        if (rw.sold_out_today) return;
        const cur = byBiz.get(rw.business_id);
        if (!cur || rw.bucks_cost < cur.min) byBiz.set(rw.business_id, { min: rw.bucks_cost, n: (cur?.n || 0) + 1 });
        else cur.n += 1;
      });
      cache = byBiz;
      return cache;
    }).catch(() => new Map());
  }
  return inflight;
};

export const useMarketRewards = () => {
  const [byBiz, setByBiz] = useState(cache || new Map());
  useEffect(() => { fetchMarket().then(setByBiz); }, []);
  return byBiz;
};
